export default "__VITE_ASSET__BCTe4fIn__"